// TestimonialsCarousel.js
import React, { useEffect, useState } from "react";
import "./LinkedinTestimonialCarousel.css";

// LinkedIn-style testimonial cards data
const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Frontend Developer at TCS",
    avatar: "https://i.pravatar.cc/150?img=5",
    content:
      "This certification boosted my career! Got placed in my dream company within 2 weeks of completing it. Highly recommended! 🚀",
    timeAgo: "2d",
    likes: 234,
  },
  {
    id: 2,
    name: "Rahul Verma",
    role: "Full Stack Developer at Infosys",
    avatar: "https://i.pravatar.cc/150?img=12",
    content:
      "The certificate added real value to my resume. Recruiters immediately noticed it during interviews. Worth every penny!",
    timeAgo: "5d",
    likes: 189,
  },
  {
    id: 3,
    name: "Sneha Patel",
    role: "Software Engineer at Wipro",
    avatar: "https://i.pravatar.cc/150?img=9",
    content:
      "Amazing learning experience! The certificate validation feature is impressive. My LinkedIn profile views increased by 300%! 💯",
    timeAgo: "1w",
    likes: 412,
  },
  {
    id: 4,
    name: "Amit Kumar",
    role: "Backend Developer at Cognizant",
    avatar: "https://i.pravatar.cc/150?img=33",
    content:
      "Best investment in my career. The tech profile feature helped me showcase my skills professionally. Got 3 interview calls!",
    timeAgo: "1w",
    likes: 298,
  },
  {
    id: 5,
    name: "Neha Singh",
    role: "React Developer at HCL",
    avatar: "https://i.pravatar.cc/150?img=23",
    content:
      "This certification stands out! Recruiters loved the verified badge. Landed a 40% salary hike. Thank you! 🙏",
    timeAgo: "2w",
    likes: 567,
  },
];

// LinkedIn-style Testimonial Card Component
const TestimonialCard = ({ testimonial }) => (
  <div className="linkedin-card">
    <div className="linkedin-card-header">
      <img
        src={testimonial.avatar}
        alt={testimonial.name}
        className="linkedin-avatar"
      />
      <div className="linkedin-user-info">
        <h4 className="linkedin-name">{testimonial.name}</h4>
        <p className="linkedin-role">{testimonial.role}</p>
        <p className="linkedin-time">{testimonial.timeAgo} • 🌐</p>
      </div>
    </div>
    <div className="linkedin-card-content">
      <p>{testimonial.content}</p>
    </div>
    <div className="linkedin-card-footer">
      <div className="linkedin-likes">
        <span className="linkedin-like-icon">👍</span>
        <span className="linkedin-like-count">{testimonial.likes}</span>
      </div>
    </div>
  </div>
);

// Infinite Carousel Component
const LinkedinTestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="testimonials-section">
      <h2 className="testimonials-title">What Our Students Say</h2>
      <div className="testimonials-carousel">
        <div
          className="testimonials-track"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {testimonials.concat(testimonials).map((testimonial, idx) => (
            <div key={idx} className="testimonial-slide">
              <TestimonialCard testimonial={testimonial} />
            </div>
          ))}
        </div>
      </div>
      <div className="carousel-dots">
        {testimonials.map((_, idx) => (
          <div
            key={idx}
            className={`carousel-dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default LinkedinTestimonialCarousel;
